import react, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios';
import * as  HiIcon from 'react-icons/hi';
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import { Interweave } from 'interweave';
const TicketMsgProp = forwardRef((props, ref) => {


    //#region Const 
    const FileInputRef = useRef();
    const [ShowModal, setShowModal] = useState(false);
    const [TicketMsgList, setTicketMsgList] = useState([]);
    const [TicketId, setTicketId] = useState(General.GuidEmpty());
    const [Number, setNumber] = useState('');
    const [Message, setMessage] = useState('');
    const [AttachmentList, setAttachmentList] = useState([]);
    const [ShowUploaderLoader, setShowuploaderLoader] = useState(false);
    const [IsDisableBtn, setIsDisableBtn] = useState(false);
    //#endregion 

    //#region Methods 

    const Attachment_Remove = (row) => {
        const allItems = [...AttachmentList];
        setAttachmentList(allItems.filter(x => x.row != row));
    }
    const AttachementFile_Change = (e) => {
        setShowuploaderLoader(true);
        if (e.target.files && e.target.files.length > 0) {
            const newAttachmentFile = [];
            for (let i = 0; i < e.target.files.length; i++) {
                if (e.target.files[i] != null && e.target.files[i] != "") {
                    let fileName = e.target.files[i].name;
                    let fileNameToken = fileName.split('.');
                    if (fileNameToken[fileNameToken.length - 1].trim().toLowerCase() == "exe") {
                        // toaster.push(General.ShowMessage("error", "کاربر گرامی! فایل انتخاب شده معتبر نمی باشد ."), ToasterOption);
                    }
                    else {
                        const selctedFile = e.target.files[i];
                        newAttachmentFile.push({
                            row: Math.floor(Math.random() * 1000000),
                            extension: fileNameToken[fileNameToken.length - 1].trim().toLowerCase(),
                            fileName: fileNameToken[0].trim().toLowerCase(),
                            file: selctedFile,
                            fileUrl: global.URL.createObjectURL(selctedFile)
                        });
                    }
                }
            }
            if (newAttachmentFile.length > 0) {
                setAttachmentList(newAttachmentFile.concat(AttachmentList));
            }
        }
        e.target.value = null;
        setShowuploaderLoader(false);

    }
    const AddNewAttachment = () => {
        FileInputRef.current.click();
    }
    const SendNewTicketMsg = () => {
        if (!Message) {
            General.ShowMsg(Enum.MsgType.error, 'کاربر گرامی! متن پیام را وارد فرمائید .');
            return;
        }
        setIsDisableBtn(true);
        let f_data = new FormData();
        f_data.append("TicketId", TicketId);

        f_data.append("Msg", Message);

        if (AttachmentList.length > 0) {
            for (let i = 0; i < AttachmentList.length; i++) {
                f_data.append("Attachments[" + i + "].Id", General.GuidEmpty());
                f_data.append("Attachments[" + i + "].File", AttachmentList[i].file);
            }
        }


        axios({
            url: General.ApiRoute() + "/TicketMsg/Insert",
            method: "POST",
            withCredentials: true,
            headers: { ApiKey: process.env.REACT_APP_APIKEY },
            data: f_data
        }).then(result => {

            if (result.data.isSuccess) {
                General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                setMessage("");
                setAttachmentList([]);
                props.onSubmit();
                setShowModal(false);
            }
            else {
                General.ShowMsg(Enum.MsgType.error, General.SaveSuccess());

            }
        }).catch(error => {
            General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));

        }).finally(_ => {
            setIsDisableBtn(false);
        })

    }

    const UpdateState = (state) => {

        var RequestOption = {
            method: "POST",
            url: General.ApiRoute() + "/Ticket/UpdateCheckState",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                id: TicketId,
                state: state,
                userId: General.GuidEmpty(),
                AgentSeenState: false,
                CreatorSeenState: false

            },
            withCredentials: true
        }
        axios(RequestOption)

            .then(function (res) {
                setShowModal(false);
            }).catch(error => {
                console.log("LOG");
                console.log(error);
            })
    }
    useImperativeHandle(ref, () => ({
        Show(TicketId, Number) {
            axios({
                url: General.ApiRoute() + "/TicketMsg/GetByTicketId",
                method: "GET",
                withCredentials: true,
                headers: {
                    ApiKey: process.env.REACT_APP_APIKEY,
                    ticketId: TicketId
                }
            }).then(result => {



                if (result.data && result.data.length) {
                    setTicketMsgList(result.data);
                    setTicketId(TicketId);
                    setNumber(Number);

                    setShowModal(true);
                    console.dir(result.data);
                }
            }).catch(error => {

            })
        }
    }))



    //#endregion 

    return (
        <rsuite.Modal open={ShowModal} onClose={() => setShowModal(false)} size="full">
            <rsuite.Modal.Header>
                <rsuite.Modal.Title>
                    <p>
                        {
                            TicketMsgList.length > 0 ?
                                TicketMsgList[0].ticketTitle
                                :
                                ""
                        }
                        {" "}
                        <span className="badge bg-dark me-1">{Number}</span>
                        {" "}
                        {/* <span className="badge bg-dark me-1">{LastStateComment}</span> */}
                    </p>
                </rsuite.Modal.Title>
            </rsuite.Modal.Header>
            <rsuite.Modal.Body>

                <div className="overflow-auto">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                            <rsuite.Col xs={24}>
                                <rsuite.Timeline align="left">
                                    {
                                        TicketMsgList.map(item => (
                                            <rsuite.Timeline.Item key={item.id}>
                                                <rsuite.Message type={`${!item.isAgentSend ? "success" : "info"}`} header={

                                                    <rsuite.Stack>
                                                        <div>
                                                            <HiIcon.HiOutlineUser size={16} className="ms-1" />
                                                            {item.senderFullName} {" "} {!item.isAgentSend ? <small> (  کارشناس پشتیبانی ) </small> : ""}
                                                        </div>
                                                        <div>
                                                            <HiIcon.HiOutlineClock size={16} className="ms-5" />
                                                            {item.createTime} {" "} - {" "} {item.createDate}
                                                        </div>
                                                    </rsuite.Stack>

                                                } >
                                                    <div className="mt-4 text-justify mb-4 TicketMsgBody" align="right">
                                                        {
                                                            item.creatorSeenState ?
                                                                <>
                                                                </> :
                                                                <IoCheckmarkDoneSharp />
                                                        }

                                                        {/* متن پیام از ویرایشگر می آید و HTML است.
                                                            Interweave آن را رندر می کند و همزمان اسکریپت و
                                                            رویدادها را پاک می کند - همان الگوی صفحه اسناد راهنما.
                                                            نکته: پیام ها از سمت مشتری هم می آیند، پس رندر خام
                                                            بدون پاکسازی اینجا یک راه نفوذ بود. */}
                                                        <Interweave content={item.msg} />
                                                    </div>
                                                    {
                                                        item.attachments && item.attachments.length > 0 && (
                                                            <>
                                                                <rsuite.Stack>
                                                                    {
                                                                        item.attachments.map(attachment => (
                                                                            <rsuite.Button
                                                                                appearance="subtle"
                                                                                target='_blank '
                                                                                title='مشاهده فایل '
                                                                                color="blue"
                                                                                href={`https://api.ticketlab.ir/files/${attachment.id}${attachment.extension}`}
                                                                            >
                                                                                <HiIcon.HiOutlineLink size={15} className="ms-1" />

                                                                                {attachment.extension}
                                                                            </rsuite.Button>
                                                                        ))
                                                                    }
                                                                </rsuite.Stack>
                                                            </>
                                                        )

                                                    }
                                                </rsuite.Message>
                                            </rsuite.Timeline.Item>
                                        ))
                                    }



                                </rsuite.Timeline>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                </div>


            </rsuite.Modal.Body>
            {/* readOnly یعنی این پنجره فقط برای خواندن باز شده - صفحه جستجوی
                تیکت ها. آنجا مدیر دارد سابقه را مرور می کند، نه رسیدگی؛ و
                دکمه «بررسی میکنم» وضعیت تیکت را عوض می کند، یعنی یک کلیک
                اشتباه روی تیکت کارشناس دیگری تاریخچه اش را دستکاری می کند.
                کارتابل خودش این prop را نمی دهد و دست نخورده می ماند. */}
            <rsuite.Modal.Footer >
                {
                    props.readOnly ?
                        null
                        :
                        <>
                            <div align="right" className='mb-2'>

                                <label>  برای ثبت پیام جدید متن را وارد فرمائید </label>
                                <rsuite.Input as="textarea" value={Message} onChange={setMessage} rows={5} />
                            </div>
                            <div>
                            </div>

                            <rsuite.Stack>


                                {

                                    AttachmentList.length > 0 ? (
                                        AttachmentList.map(item => (
                                            <>
                                                <rsuite.Tag closable onClose={() => Attachment_Remove(item.row)}   >

                                                    <a href={item.fileUrl} target='_blank'>

                                                        {item.fileName}
                                                        {"."}
                                                        {item.extension}
                                                    </a>
                                                </rsuite.Tag>

                                            </>
                                        ))
                                    ) : null
                                }
                            </rsuite.Stack>
                            <rsuite.Button appearance="default" className="me-2" onClick={AddNewAttachment}><HiIcon.HiPlus size={14} /> انتخاب فایل پیوست</rsuite.Button>
                            <rsuite.Button appearance='default' onClick={() => UpdateState(Enum.StateType.Checking)} className='me-2'>
                                بررسی میکنم
                            </rsuite.Button>
                            {
                                !IsDisableBtn ?
                                    <rsuite.Button appearance="primary" color="green" disabled={IsDisableBtn} className="me-2" onClick={SendNewTicketMsg}>
                                        ثبت پیام جدید
                                    </rsuite.Button>
                                    :
                                    <rsuite.Button appearance="primary" color="green" className="mt-2" disabled>
                                        <rsuite.Loader content="در حال ارسال اطلاعات..." />
                                    </rsuite.Button>
                            }
                        </>
                }
                <rsuite.Button appearance="default" className="me-2" onClick={() => setShowModal(false)}>
                    بستن
                </rsuite.Button>
                {
                    props.readOnly ?
                        null
                        :
                        !ShowUploaderLoader ?
                            <input type="file" ref={FileInputRef} style={{ display: "none" }} multiple onChange={AttachementFile_Change} />
                            :
                            <rsuite.Button appearance="primary" className="mt-2" disabled>
                                <rsuite.Loader content="در حال ارسال اطلاعات..." />
                            </rsuite.Button>
                }

            </rsuite.Modal.Footer>
        </rsuite.Modal>
    )
})

export default TicketMsgProp;